import { Component, forwardRef, Input } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

const flokNumberInputAccessor: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FlokNumberInputComponent)
}

@Component({
    providers: [flokNumberInputAccessor],
    selector: 'app-flok-number-input',
    styleUrls: ['flok-number-input.scss'],
    templateUrl: 'flok-number-input.html'
})
export class FlokNumberInputComponent implements ControlValueAccessor {
    @Input() max: number | undefined
    @Input() min: number | undefined
    onChange: (value: number) => void
    onTouched: () => void
    value: number
    disabled = false

    // Public
    registerOnChange(onChange) {
        this.onChange = onChange
    }

    registerOnTouched(onTouched) {
        this.onTouched = onTouched
    }

    minus() {
        if (this.disabled) { return }
        if (this.value <= this.min) { return }

        this.value--
        this.onChange(this.value)
    }

    plus() {
        if (this.disabled) { return }
        if (this.value >= this.max) { return }

        this.value++
        this.onChange(this.value)
    }

    writeValue(value: number | undefined) {
        if (this.disabled) { return }
        this.value = value !== undefined ? value : 0
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled
    }
}
